module.exports = __webpack_public_path__ + "static/media/front-strieght.84d7cafb.png";